// extracted by mini-css-extract-plugin
export default {"bg":"Admin_bg__dWtk2","card":"Admin_card__82BSe","cardContent":"Admin_cardContent__tYjfJ","txt":"Admin_txt__+8+f-","txt2":"Admin_txt2__CLDM8","bt":"Admin_bt__qFXLl"};